import React, {useState} from 'react';
import {Tabs} from "antd";
import {URLS} from "@/lib/urls";
import AdminLayout from "@/components/layout/admin/adminLayout";
import {useParams} from "react-router-dom";
import toFaNumber from "@/lib/utils/number";
import EditSurveySection from "@/pages/admin/survey/edit/_section/editSurveySection";
import QuestionSurveySection from "@/pages/admin/survey/edit/_section/questionSurveySection";
import SurveySettingSection from "@/pages/admin/survey/edit/_section/SettingBlock";
import QuestionWithResultSurveySection from "@/pages/admin/survey/edit/_section/questionWithResultSurveySection";
import QuestionWithTextResultSurveySection
    from "@/pages/admin/survey/edit/_section/questionWithTextResultSurveySection";
import {hasPermission} from "@/components/can/Can";
import PermList from "@/lib/helper/PermList";

function AdminSurveyEditPage() {

    const param = useParams()
    const id = param.id;


    const [myTab, setMyTab] = useState('edit')

    const myBreadCrumb = [
        {
            path: URLS.homepage,
            title: "خانه"
        },
        {
            path: URLS.admin.survey.dashboard,
            title: "نظرسنجی"
        },
        {
            path: URLS.pwd,
            title: " ویرایش نظر سنجی " + toFaNumber(id)
        },

    ]


    const onChange = key => {
        setMyTab(key)
    };
    const items = [
        {
            key: 'edit',
            label: 'ویرایش مشخصات',
        },
        {
            key: 'question',
            label: 'سوالات',

        },
        {
            key: 'setting',
            label: 'تنظیمات',

        },
    ];

    if (hasPermission(PermList.SURVEY_EDIT)) {


        items.push({
            key: 'report',
            label: 'نتایج آماری',

        });
        items.push(
            {
                key: 'report_text',
                label: 'نتایج سوالات تشریحی',

            })
    }


    return (<>
            <AdminLayout pageTitle={'ویرایش نظر سنجی'} breadCrumb={myBreadCrumb}>
                <Tabs
                    rootClassName={'mx-2'}
                    type={'line'}
                    defaultActiveKey="1" items={items} onChange={onChange}/>

                {myTab === 'edit' && <EditSurveySection/>}
                {myTab === 'question' && <QuestionSurveySection/>}
                {myTab === 'setting' && <SurveySettingSection/>}
                {myTab === 'report' && <QuestionWithResultSurveySection/>}
                {myTab === 'report_text' && <QuestionWithTextResultSurveySection/>}

            </AdminLayout>
        </>
    )
}

export default AdminSurveyEditPage;


